import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// A custom SCSS build (variable overrides -> Bootstrap source), not the
// precompiled default theme - see assets/bootstrap-custom.scss.
import '@/assets/bootstrap-custom.scss'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
